import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchCategories } from '../../actions/pos';
import Spinner from '../shared/spinner';
import _ from "lodash";

class SelectCategory extends Component {

    componentDidMount() {
        this.props.fetchCategories('active');
    }

    setCategory(category) {
        this.props.callbackToUpdateComponent({ category: category })
    }

    renderCategories() {
        return _.map(this.props.categories, (category) => {
            return (
                <div className='col-lg-2 col-md-3 col-xs-6' key={category.id} onClick={this.setCategory.bind(this, category)}>
                    <div className="thumbnail">
                        <img src={category.image} alt='' />
                        <div className="caption">
                            <h4 className='thumbnail-title'>{category.description}</h4>
                            <p>
                                <button onClick={this.setCategory.bind(this, category)} className="btn btn-sm btn-primary">See Products</button>
                            </p>
                        </div>
                    </div>
                </div>
            )
        })
    }

    render () {
        const {categories} = this.props;
        if (!categories) {
            return <Spinner/>;
        } else {
            return(
                <div>
                    <div className='col-xs-12 col-md-12 col-lg-12 text-right mb-15'>
                        {this.props.cart && <button className='btn btn-primary' onClick={this.props.checkout}>Checkout</button>} &nbsp;
                        <button className='btn btn-primary' onClick={this.props.toggleCart}>View Cart</button> &nbsp;
                    </div>
                    {this.renderCategories()}
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    const { categories } = state;
    return { categories };
}

export default connect(mapStateToProps, { fetchCategories })(SelectCategory);



// WEBPACK FOOTER //
// ./src/components/pos/selectCategory.js